import moment from "moment";
import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useTimesheetProvider } from "../../../../../../Providers/Consultant/Timesheet";
import Back from "../../../../../../Components/Back";
import CustomTable from "../../../../../../Components/Table";
import { timesheetStatus } from "../../../../../../Utils/constants";
import { useNavigate, useParams } from "react-router-dom";

const Daywise = ({
  showDatePicker = false,
  job = null,
  setShowTimesheetDetails,
}) => {


  const [status, setStatus] = useState(timesheetStatus.none);
  const [comments, setComments] = useState(null)

  const {
    selectedTimesheet,
    timesheetDetails,
    setSelectedTimesheet,
    timesheets,
    fetchTimesheetsByDate,
  } = useTimesheetProvider();

  const [rows, setRows] = useState([]);
  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    setSelectedTimesheet(id)
  }, [])
  useEffect(() => {
    const cur = timesheets?.find((t) => t.id === selectedTimesheet);
    setComments(cur?.clientComments)
    setStatus(cur?.status ?? timesheetStatus.none);
  }, [selectedTimesheet]);

  useEffect(() => {
    setRows(timesheetDetails?.[selectedTimesheet] ?? []);
  }, [selectedTimesheet, timesheetDetails]);

  const headCells = ["Date", "Hours", "Description"];
  const CustomRow = ({ row }) => {
    return (
      <TableRow
        key={row.id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell width="20%" component="th" scope="row">
          {moment.utc(row.date).format("dddd, MMMM DD, YYYY")}
        </TableCell>
        <TableCell width="20%">
          {row.hours.toString().padStart(2, "0")}:
          {row.minutes.toString().padStart(2, "0")}
        </TableCell>
        <TableCell className="truncate max-w-[250px] grow">{row.description}</TableCell>
      </TableRow>
    );
  };
  return (
    <div className="relative">
      <div
        className={`flex flex-row gap-x-3 font-medium text-[18px] items-center ${showDatePicker ? "mb-6" : "mb-2"
          }`}
      >
        <Back
          onClick={() => {
            navigate("/dashboard/timesheetscard")
          }}
          className=""
        />
        <span>Timesheet</span>
      </div>
      <div className="flex justify-end py-4">
        <div
          className="px-2 py-1 rounded-[5px] font-[18px] leading-[22px]"
          style={
            status === timesheetStatus.approved
              ? { backgroundColor: "#2EBAA34D", color: "#2EBAA3" }
              : { background: "#FF33334D", color: "#FF3333" }
          }
        >
          {status[0] + status.slice(1).toLowerCase()}
        </div>
      </div>
      {comments ? (
        <div className="flex flex-col bg-white p-4 mb-4 rounded-lg">
          <span
            className={
              status === timesheetStatus.approved
                ? "text-[#139588] font-medium"
                : "text-red-500 font-medium"
            }
          >
            Message
          </span>
          <span className="w-full text-sm">{comments}</span>
        </div>
      ) : null}
      <CustomTable
        headCells={headCells.map((heading) => ({ label: heading }))}
        rows={rows}
        CustomRow={CustomRow}
        showPagination={false}
      />
    </div>
  );
};

export default Daywise;

